import { render, staticRenderFns } from "./IncomeInputs.vue?vue&type=template&id=7bc4afd6&scoped=true"
import script from "./IncomeInputs.vue?vue&type=script&lang=js"
export * from "./IncomeInputs.vue?vue&type=script&lang=js"
import style0 from "./IncomeInputs.vue?vue&type=style&index=0&id=7bc4afd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4afd6",
  null
  
)

export default component.exports